import { render } from "./slidesticker-21.vue?vue&type=template&id=aa35fb84&scoped=true"
import script from "./slidesticker-21.vue?vue&type=script&lang=js"
export * from "./slidesticker-21.vue?vue&type=script&lang=js"

import "./slidesticker-21.vue?vue&type=style&index=0&id=aa35fb84&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa35fb84"]])

export default __exports__